import { decryptData, encryptData } from "config/config";
import { instance as axios } from "config/axiosInstance";
import { getBrowserName, isLoggedIn } from "config/utils";

// Postal code documents
export const postalFolder = async (data = {}) => {
  const token = isLoggedIn();
  return decryptData(
    await axios.get(
      `/postal/folder?reqData=${encryptData({
        ...data,
        platformType: getBrowserName(),

        access_token: token,
      })}`
    )
  );
};

// Postal code documents
export const newpostalFolder = async (data = {}) => {
  const token = isLoggedIn();
  return decryptData(
    await axios.get(
      `/postal/folder/by-course?reqData=${encryptData({
        ...data,
        platformType: getBrowserName(),

        access_token: token,
      })}`
    )
  );
};
// Postal code documents
export const postalContent = async (data = {}) => {
  const token = isLoggedIn();
  return decryptData(
    await axios.get(
      `/postal/content?reqData=${encryptData({
        ...data,
        platformType: getBrowserName(),
        access_token: token,
      })}`
    )
  );
};
